import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Smartphone, Zap, Wrench, Euro } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-115">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-blue-100 text-blue-800 px-4 py-1.5 rounded-full text-xs md:text-sm font-bold mb-6 border border-blue-200" data-id="element-117">
          🔌 Para personas que quieren resolver sus averías eléctricas sin pagar
          electricista
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-3xl md:text-5xl font-black text-gray-900 leading-tight mb-8" data-id="element-118">
          ¿Cansado de Pagar 80€ por 15 Minutos de Trabajo que Podrías Hacer Tú
          Mismo?
        </motion.h1>

        <motion.a href="#compra" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="w-full max-w-2xl mb-8 block cursor-pointer hover:opacity-95 transition-opacity" data-id="element-119">
          <img src="https://cdn.magicpatterns.com/uploads/w1FaxP4vjCZkpk4XumuSa9/mockup_sin_upsell_webp.webp" alt="Colección Básica Electricista en Casa" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-120" />
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl text-gray-700 font-medium mb-8 max-w-3xl" data-id="element-121">
          El sistema paso a paso que ya usan miles de personas en España para
          resolver el 90% de las averías eléctricas domésticas sin título, sin
          experiencia y sin arriesgar nada.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-122">
          <div className="flex items-center gap-1.5 bg-gray-100 px-3 py-1.5 rounded-md text-sm font-semibold text-gray-800 border border-gray-200" data-id="element-123">
            <Zap size={16} className="text-yellow-500" data-id="element-124" /> sin conocimientos
            previos
          </div>
          <div className="flex items-center gap-1.5 bg-gray-100 px-3 py-1.5 rounded-md text-sm font-semibold text-gray-800 border border-gray-200" data-id="element-125">
            <Wrench size={16} className="text-gray-500" data-id="element-126" /> herramientas básicas
          </div>
          <div className="flex items-center gap-1.5 bg-gray-100 px-3 py-1.5 rounded-md text-sm font-semibold text-gray-800 border border-gray-200" data-id="element-127">
            <Euro size={16} className="text-green-600" data-id="element-128" /> ahorrás 400€-800€ al
            año
          </div>
          <div className="flex items-center gap-1.5 bg-gray-100 px-3 py-1.5 rounded-md text-sm font-semibold text-gray-800 border border-gray-200" data-id="element-129">
            <Smartphone size={16} className="text-blue-500" data-id="element-130" /> acceso inmediato
          </div>
        </motion.div>

        <motion.a href="#compra" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="bg-yellow-400 hover:bg-yellow-500 text-black font-black text-lg md:text-2xl py-4 md:py-5 px-8 md:px-12 rounded-lg shadow-[0_5px_0_rgb(202,138,4)] hover:shadow-[0_2px_0_rgb(202,138,4)] hover:translate-y-[3px] transition-all w-full max-w-xl text-center uppercase tracking-wide" data-id="element-131">
          🔌 QUIERO RESOLVER MIS AVERÍAS YO MISMO →
        </motion.a>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="mt-4 flex flex-wrap justify-center gap-4 text-sm text-gray-600 font-medium" data-id="element-132">
          <span className="flex items-center gap-1" data-id="element-133">
            <Shield size={16} className="text-green-600" data-id="element-134" /> Garantía 30 días
          </span>
          <span className="hidden md:inline" data-id="element-135">•</span>
          <span className="flex items-center gap-1" data-id="element-136">
            <Smartphone size={16} className="text-blue-600" data-id="element-137" /> Acceso inmediato
          </span>
          <span className="hidden md:inline" data-id="element-138">•</span>
          <span data-id="element-139">Sin suscripción</span>
        </motion.div>
      </div>
    </section>;
}